export default "__VITE_ASSET__UU6lgW61__"